"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Merchant =
/** @class */
function () {
  function Merchant(obj) {
    this.merchantId = obj.merchantId;
    this.merchantName = obj.merchantName;
    this.shopVolumeId = obj.shopVolumeId;
    this.shopCategoryId = obj.shopCategoryId;
    this.merchantTypeId = obj.merchantTypeId;
    this.nationFoodCategories = obj.nationFoodCategories;
    this.foodCategories = obj.foodCategories;
  }

  return Merchant;
}();

exports.Merchant = Merchant;